
  <router-view :key="$route.fullPath" />
